// 討論場の決まり（サーバーと画面の両方で使う）
import type { Slot } from './types';

const MIN = 60 * 1000, HOUR = 60 * MIN;

export type DebateKind = '主張' | '反論' | 'まとめ';
// 主張（各チーム1回）→ 反論（交互に1回ずつ）→ まとめ（各チーム1回）
export const DEBATE_STEPS: { side: Slot; kind: DebateKind; limit: number }[] = [
  { side: 'A', kind: '主張', limit: 1 * HOUR }, { side: 'B', kind: '主張', limit: 1 * HOUR },
  { side: 'A', kind: '反論', limit: 3 * HOUR }, { side: 'B', kind: '反論', limit: 3 * HOUR },
  { side: 'A', kind: 'まとめ', limit: 3 * HOUR }, { side: 'B', kind: 'まとめ', limit: 3 * HOUR },
];
export const DEBATE_BANK = 24 * HOUR;   // 各チームが待ってもらえる持ち分
export const DEBATE_MAX: Record<DebateKind, number> = { '主張': 800, '反論': 400, 'まとめ': 400 };   // 長さで押し切れないように
export const ANSWER_MAX = 200;
export const QUESTION_MAX = 100;
export const URGENT = 15 * MIN;          // 残りがこれを切ったら、1人でも提出できる
export const DEBATE_RULE: Record<DebateKind, string> = {
  '主張': 'あなたのチームの主張と、その根拠を書きます。',
  '反論': '相手の主張への反論と、相手からの反論への再反論を書きます。相手に質問もできます（2つまで）。',
  'まとめ': 'これまでに出た論点だけを使ってまとめます。新しい論点を出すと、相手チームから「後出し」を指摘されることがあります。',
};
export const WAIT_CHOICES = [1, 3, 6, 12, 24];   // 待ってもらう長さ（時間）

// 提出に必要な「これで出す」の数：チームの過半数
export const teamNeed = (members: number) => Math.floor(members / 2) + 1;

export interface DebateClock { status: string; step: number; step_started_at: number | null; extra_ms: number }
export function debateDeadline(d: DebateClock): number | null {
  if (d.status !== 'live' || d.step >= DEBATE_STEPS.length || d.step_started_at == null) return null;
  return d.step_started_at + DEBATE_STEPS[d.step].limit + d.extra_ms;
}
